import ReceiveNotify from './ReceiveNotify';

export default ReceiveNotify;
